import { createStore } from "vuex";
import mainMovies from "./mainMovies";
import listMovies from "./listMovies";
import hlsStore from "./hlsStore";
import isWorldStore from "./isWorldModule";
import searchMovies from "./searchMovies";
import playerComplains from "./playerComplains";
import seo from "./seo";
import verifyAccess from "./verifyAccess";
import movieFilter from "./movieFilter";
import paymentStore from "./paymentStore";
import chanels from "./chanels";
import error from "./error";
import mainBanners from "./mainBanners";
import mainPage from "./mainPage";
import uzb from "./uzb";
import user from "./user";
import search from "./search";
import movieRating from "./movieRating";
import paymentModal from "./paymentModal";
import news from "./news";
import notifications from "./notifications";
import telegram from "./telegram";

const store = createStore({
    modules: {
        verifyAccess,
        mainMovies,
        listMovies,
        hlsStore,
        isWorldStore,
        playerComplains,
        searchMovies,
        movieFilter,
        seo,
        paymentStore,
        chanels,
        error,
        mainBanners,
        mainPage,
        uzb,
        search,
        user,
        movieRating,
        paymentModal,
        news,
        seo,
        notifications,
        telegram,
    },
});

export default store;
